import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ModalAlert from '../ModalAlert/ModalAlert.js'
import queryString from "query-string";
import { useCookies } from 'react-cookie'
import { post as internalPost } from '../../lib/iframeApi'
import DealList from '../DealList/DealList';
import DealForm from '../DealForm/DealForm';
import { LIST, EDIT, CREATE, AUTHCOOKIENAME } from '../../config/routes';
import * as actions from './App.actions';
import * as dealActions from '../DealList/DealList.actions';
import PrivateRoute from '../Components/PrivateRoute';
import './App.css';

const App = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const store = useSelector(store => store);
  const currentStoreId = store.app.storeId;
  const currentRetailerCode = store.app.retailerCode;
  const currentLang = store.app.selectedLanguage;
  const perPage = store.list.perPage;

  const [cookies, setCookie] = useCookies([AUTHCOOKIENAME]);

  const qs = queryString.parse(window.location.search);

  const lang = qs.lang;
  const token = qs.token;
  const center = qs.centre;
  const mc_store_id = qs.store;

  useEffect(() => {
    if (lang && lang.length && lang !== currentLang) {
      i18n.changeLanguage(lang);
      dispatch(actions.setLanguage(lang))
    }
  }, [lang, dispatch, i18n, currentLang])

  useEffect(() => {
    if (token) {
      internalPost('/mallcomm/authenticate', { token, store: mc_store_id, center })
        .then((response) => {
          if(!response.ok) { throw Error(response.statusText); }
          return response.json();
        })
        .then((data) => {
          const cookieInfo = JSON.stringify({
            id: data.id,
            first_name: data.first_name,
            last_name: data.last_name,
            user: data.email,
            token: data.token,
            expires: data.expires,
            store_id: data.store_id
          });

          setCookie(AUTHCOOKIENAME, cookieInfo, {path: '/', expires: new Date(Date.parse(data.expires))})
          return data.store_id;
        })
        .then((storeId) => {
          if (storeId && storeId !== currentStoreId) {
            dispatch(actions.setStoreId(storeId))
            dispatch(actions.getStoreInfo(storeId));
            dispatch(dealActions.getDealList(storeId, perPage));
          }
        })
        .catch((error) => {
          console.log(error);
          alert('failed to authenticate user');
          window.close();
        });
    } else if(cookies[AUTHCOOKIENAME]) {
      let attr = cookies[AUTHCOOKIENAME];

      if(!attr.token) {
        alert('session has expired')
        window.close();
      }
    } else {
      alert('no auth token')
      window.close();
    }
  }, [token, mc_store_id, center, dispatch, currentStoreId, perPage, setCookie])

  useEffect(() => {
    if (currentStoreId && currentStoreId.length) {
      dispatch(actions.getStoreInfo(currentStoreId));
      dispatch(dealActions.getDealList(currentStoreId, perPage));
    }
  }, [currentStoreId, dispatch, perPage])

  useEffect(() => {
    if (currentRetailerCode && currentRetailerCode.length) {
      dispatch(actions.getRetailerInfo(currentRetailerCode));
    }
  }, [currentRetailerCode, dispatch])

  return (
    <div className="App">
      <div className="environment-indicator"></div>
      <div className="master-container">
        <BrowserRouter>
          <Switch>
            <PrivateRoute exact path={LIST}>
              <DealList />
            </PrivateRoute>
            <PrivateRoute path={[CREATE, EDIT]}>
              <DealForm />
            </PrivateRoute>
          </Switch>
        </BrowserRouter>
        <span style={{ wordWrap: "break-word", color: "#F5F5F5" }}>{window.location.toString()}</span>
      </div>
      <ModalAlert />
    </div>
  );
}

export default App;
